// const getRegionConfigs
import { isProd } from '../utils/common';

export const apiGetRegionConfigs = isProd()
  ? 'https://i18n.mykeeta.com/api/openapi/v1/getRegionConfigs'
  : 'https://ocean.waimai.test.sankuai.com/api/openapi/v1/getRegionConfigs';

export const SHOP_APIS = [
  '/api/v1/shop/productList',
  '/api/v1/shop/shopInfo',
  '/api/v1/shop/productSpecifics',
  '/api/v1/shop/product/render',
  '/api/v1/shop/searchProduct',
];

// '/api/h5/v1/homePage/homeShopList',
export const H5_NEW_APIS = [
  '/api/v1/homePage/homeShopList',
  '/api/v2/homePage/homeShopList',
  '/api/v3/homePage/homeShopList',
  '/api/v4/homePage/homeShopList',
  '/api/v1/category/kingKongPage',
  '/api/v2/homePage/pickUpShopList',
  '/api/v1/special/common/page',
  '/api/v1/special/fixedPrice/landingProductList',
  '/api/v1/search/globalpage',
];

// '/api/v1/h5/homePage/homeShopList',
export const H5_NEW_I_APIS = [
  // '/api/v1/shop/productList',
  // '/api/v1/shop/shopInfo',
  // '/api/v1/shop/productSpecifics',
  // '/api/v1/shop/product/render',
  // '/api/v1/shop/searchProduct',
];

export const H5_NEW_M_APIS = [
  '/api/v1/shop/shopInfo',
  '/api/v1/shop/productList',
];
